// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1NNyY","content":"LayoutSettings_content__2aEAf"};